import Modal from "components/Models/index";
import React, { useState } from "react";
import linkImage from "assets/images/fileImage/link.svg";
import linkImageDark from "assets/images/fileImage/linkImageDark.svg";
import pdf from "../../../../assets/images/homepage/ySafe/tableIcons/pdf.svg";
import xls from "../../../../assets/images/homepage/ySafe/tableIcons/xls.svg";
import Input from "components/Input/index";
import Button from "components/Button/index";
import "./shareFile.scss";
import useScreenMobile from "hooks/useScreen";
import useTheme from "hooks/observer";
import Drawer from "components/Drawer/index";

const ShareFileContent = ({ handleCancel, checkedRows, sharedData }) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState("");

  const handleInput = (e) => {
    setInputValue(e.target.value);
  };

  const copyLink = () => {
    navigator.clipboard.writeText("yourLinkHere").then(() => {
      alert("Link copied to clipboard!");
    });
  };

  return (
    <div className={`shareFile ${theme === "light" ? "" : "shareFileDark"}`}>
      <div className="shareFileWrapper">
        <div className="shareFileWrapperTop">
          <Input
            value={inputValue}
            type="text"
            width="93%"
            placeholder="Add Name, Group or Email address"
            label="Invite people"
            onChange={handleInput}
          />
        </div>
        <div className="shareFileWrapperMain">
          <div className="accessPeopleList">
            {sharedData?.map((ele, ind) => (
              <div className="accessPeopleDetail" key={ind}>
                <img src={ind % 2 === 0 ? xls : pdf} alt="file type" />
                <h1>{ele.name}</h1>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="shareFileFooter">
        <p onClick={copyLink} style={{ cursor: "pointer" }}>
          <img src={theme === "light" ? linkImage : linkImageDark} alt="" />
          Copy Link
        </p>
        <Button title="Share" type="violet" width="17%" />
      </div>
    </div>
  );
};

const ShareFiles = ({ handleCancel, sharedData, checkedRows }) => {
  const isMobile = useScreenMobile({ size: 992 });

  return isMobile ? (
    <Drawer
      handleCancel={handleCancel}
      isVisible={true}
      heading={`Share ${Object?.keys(checkedRows)?.length} Files`}
      showFooter={false}
      width="35% !important"
      showCross={true}
    >
      <ShareFileContent
        handleCancel={handleCancel}
        checkedRows={checkedRows}
        sharedData={sharedData}
      />
    </Drawer>
  ) : (
    <Modal
      showFooter={false}
      handleCancel={handleCancel}
      heading={`Share ${Object?.keys(checkedRows)?.length} Files`}
    >
      <ShareFileContent
        handleCancel={handleCancel}
        checkedRows={checkedRows}
        sharedData={sharedData}
      />
    </Modal>
  );
};

export default ShareFiles;
